


























import { Component, Vue, Provide, Prop } from 'vue-property-decorator';
import { timeFormatSecond } from "@/utils";
import { pagnition } from "@/utils/commonConfig";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";


@Component({
    name: 'saleRecord'
})
export default class CombinationProperty extends Vue {
    @Provide() private pagerCount: any = 0; //总条数
    @Provide() private pageSize: any = 20;
    @Provide() private pageIndex: any = 1;  //当前页
    @Provide() private pagnition: any = pagnition;


    @Provide() private tableData: any = [] ;
    @Provide() private sortCondition: any = {
        prop: null,
        order: null
    };


    private mounted(){
        this.getCaseRecord()
    }
    //获取 电销 详情
    private async getCaseRecord () {
        const { getPhoneSaleCaseLogReq, getPhoneSaleCaseLogRequest }: any = await import("@/request/phoneSale");
        let arg = {
            caseid:this.$route.query.id,
            Page:{
                pageSize:this.pageSize,
                pageIndex:this.pageIndex,
                prop: this.sortCondition.prop,
                order:this.sortCondition.order
            }
        }
        let res = await getPhoneSaleCaseLogRequest.handleHttp(getPhoneSaleCaseLogReq(arg),null);

        if (res && res.right) {
            let list = res.listList
            list.forEach((item:any)=>{
                item.phonetime = item.phonetime != 0 ? timeFormatSecond(item.phonetime) : 0
            })
            this.tableData = res.listList
            this.pagerCount = res.pageout.total
        }
    }

    private sortChange(val: any) {
        // 拨打时间
        switch (val.prop) {
            case "phonetime":
            this.sortCondition.prop = Sort.SORT_BY_PHONE_TIME;
            break;
        }
        //正序或者倒序
        switch (val.order) {
            case "descending":
                this.sortCondition.order = Rank.RANK_DESC;
                break;
            case "ascending":
                this.sortCondition.order = Rank.RANK_ASC;
                break;
            default:
                this.sortCondition.order = Rank.RANK_UNSPECIFIED;
                break;
        }
        this.getCaseRecord();
    }

    private handleCurrentChange(val: any) {
        this.pageIndex = Number(val);
        this.getCaseRecord()
        //展示表格数据
    }

    //点击上一页
    private handlePrevChange(val: any) {
        if (this.pageIndex > 0) {
            //展示表格数据
            this.getCaseRecord()
        }
    }

    //点击下一页
    private handleNextChange(val: any) {
        //展示表格数据
        this.getCaseRecord()
    }

    private handleSizeChange(val: any) {
        this.pageSize = Number(val);
        this.getCaseRecord()
        //展示表格数据
    }

}
